"use strict";

exports.__esModule = true;
exports.onRouteUpdate = void 0;

var onRouteUpdate = function onRouteUpdate(_ref, pluginOptions) {
  var location = _ref.location;

  if (process.env.NODE_ENV !== "production" || typeof clicky !== "object") {
    return null;
  } // We need to send page views manually because Gatsby websites don't refresh


  var sendPageView = function sendPageView() {
    var pagePath = location ? location.pathname + location.search + location.hash : undefined;
    clicky.log(pagePath, document.title, 'pageview');
  }; // Minimum delay for reactHelmet's requestAnimationFrame


  setTimeout(sendPageView, 32);
  return null;
};

exports.onRouteUpdate = onRouteUpdate;